<div class="flex md:flex-row flex-col gap-6 items-center justify-between mb-6">
  <h2 class="self-start">{{'personalizedJourney.title' | transloco}}</h2>
  <div class="flex flex-col gap-[0.8rem] items-end self-end">
    <progression-bar />
    @if(userRole()!="User"){
    <toggle
      [isActive]="modeDraft()"
      (toggleChange)="toggleDraftMode()"
      [text]="'components.toggle.showPendingTiles' | transloco"
    ></toggle>
    }
    <app-button
      [text]="'personalizedJourney.clarify.resetResearch' | transloco"
      [variant]="'secondary'"
      [icon]="'back'"
      [iconSize]="'1.5rem'"
      [size]="'sm'"
      (buttonClick)="redirectToJourneyResearch()"
    ></app-button>
  </div>
</div>

<div class="flex flex-col gap-6 mb-20">
  <app-journey-breadcrumb />
  <div
    class="flex flex-col gap-4 md:gap-10 py-6 px-4 md:p-6 rounded-xl bg-white"
  >
    <h3>{{ 'personalizedJourney.offerDiscovery.title' | transloco }}</h3>
    <div class="flex flex-col gap-6 md:gap-10 p-4 bg-vinciLavender rounded-xl">
      <h3 class="flex items-center gap-5">
        <icon [name]="'thumb-up'" [size]="'1.875rem'"></icon>{{
        'personalizedJourney.offerDiscovery.openPositions' | transloco }}
      </h3>
      @if (jobLoading()) {
      <div class="my-[6.25rem]"><loader /></div>
      } @else { @if(jobs().length === 0){
      <p class="text-center">
        {{ 'personalizedJourney.offerDiscovery.noOfferFound' | transloco }}
      </p>
      } @else {
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-fr">
        @for (job of jobs(); track $index) {<app-card-result-small
          [title]="job.title"
          [text]="job.text"
          [image]="job.image"
          [link]="job.link"
          [variant]="$index % 4 === 0 ? 'primary' : $index % 4 === 1 ? 'tertiary' :  $index % 4 === 2 ? 'quaternary' : 'quinary'"
        />}
      </div>
      } @if(extraJobsLoading()) {
      <div class="my-[6.25rem]"><loader /></div>
      }

      <div class="flex flex-col sm:flex-row justify-end gap-6">
        @if (store.jobsPagination() !== null && store.jobsPagination().total >
        store.jobs().length) {
        <app-button
          [text]="'personalizedJourney.offerDiscovery.seeMoreJobs' | transloco"
          [variant]="'primary'"
          [disabled]="extraJobsLoading()"
          (buttonClick)="loadMoreJobs()"
        ></app-button>
        }
      </div>

      @if(isRequestErrorModalOpen()){
      <app-modal
        [title]="'personalizedJourney.offerDiscovery.errorModalTitle' | transloco"
        [text]="'personalizedJourney.offerDiscovery.errorModalText' | transloco"
        [buttonText]="'personalizedJourney.offerDiscovery.errorModalCtaText' | transloco"
        (closeModal)="closeRequestErrorModal()"
        (completeModal)="closeRequestErrorModalAndRedirectToJobResearch()"
      ></app-modal>
      } }
    </div>

    <div class="flex flex-col gap-6 pb-[5rem]">
      @if(tilesLoading()){
      <loader />
      } @else { @for (tile of tilesOfferDiscoveryToShow(); track $index) {
      <app-tile
        class="rounded-xl"
        [id]="tile.id"
        [title]="tile.title"
        [text]="tile.text"
        [variant]="'tertiary'"
        [ctaText]="'personalizedJourney.offerDiscovery.discoverCtaText' | transloco"
        [ctaLink]="tile.ctaLink"
        [image]="tile.image"
        [size]="tile.size"
        [isRedirectionExternal]="tile.isExternalLink"
        [textDisclaimer]="tile.textDisclaimer"
        [status]="tile.status"
      ></app-tile>
      } }
    </div>
  </div>
</div>

<app-favorite-tile-error-modal />